import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"

export default class StoresTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      live: props.live,
      company: props.company,
    }

    this.table = React.createRef()
  }

  _getColumns() {
    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: store => moment(store.created_at).format('DD MMM YYYY')
      },
      {
        Header: 'Store',
        id: 'name',
        accessor:  store => store.name
      },
    ]
  }

  render() {
    let {
      company,
    } = this.state

    const columns = this._getColumns()

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Stores}?company_id=${company?.id || ""}`}
          noDataMessage={"No stores found"}
          title={this.props.title}
          columns={columns}
          showExport={false}
          showHeader={false}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
        />
      </div>
    )
  }
}

StoresTable.defaultProps = {
  latestResults: false
}
